import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const todoist = defineConnector({
  identifier: "todoist",
  name: "Todoist",
  tagLine: "Task management",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.todoist\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get your API token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [Todoist Integrations settings](https://app.todoist.com/app/settings/integrations/developer) and copy your API token.",
        },
      ],
    },
    {
      title: "Paste your API token",
      items: [
        {
          kind: "input",
          label: "Todoist API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.todoist.com/api/v1/projects",
  },
});
